import React from "react";
import logger from "logger";
import WonItemsPopup from "./WonItemsPopup";
import { showDialog } from "DialogProvider";

export const WonItemsWithDialog = ({ label, countlabel, value }) => {
  const showWonItems = () => {
    logger.log("show values", value);
    if (!value || value.length == 0) {
      alert("No items to show.");
      return;
    }
    showDialog(<WonItemsPopup open={true} items={value} heading={label} />);
  };

  /*
  <WonItemsWithDialog
          label={"Won Items"}
          value={task.taskstatusdetail.itemswon}
        />
  */
  return (
    <>
      <div
        className="infokey enlargeonhover"
        style={{ fontSize: "10px" }}
        onClick={showWonItems}
      >
        {label}
        <span style={{ float: "right", fontWeight: "bold", color: "red" }}>
          [See Details]
        </span>
      </div>
      <div className="infovalue">
        {countlabel}:{value ? value.length : ""}
      </div>
    </>
  );
};
